import { PaginatedDataDTO, PaginationDTO } from '@bottega52/commons-pagination';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { SearchOutlined } from '@material-ui/icons';
import { Stack } from '@mui/system';
import { DataGrid, GridColumns, GridRenderCellParams } from '@mui/x-data-grid';
import _ from 'lodash';
import * as React from "react";
import moment from 'moment';
import translations from '../../translations/i18next';
import ReduxLanguage from '../ReduxLanguage';
import { ICustomerContractInDTO } from '../../repository/jago/model/input/ICustomerContractInDTO';
import { ICustomerContractServiceInDTO } from '../../repository/jago/model/input/ICustomerContractServiceInDTO';
import { getCustomerContractStatusColor } from '../../utils/Utils';
import { ICustomerInDTO } from '../../repository/jago/model/input/ICustomerInDTO';
import CustomersIcon from '@material-ui/icons/GroupOutlined';
import DomainsIcon from '@material-ui/icons/Domain';

const styles = createStyles({
  rowContainer: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column'
  },
  rowBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowTitle: {
    fontWeight: 'bold'
  },
  logo: {
    width: '20%',
  },
});

export interface ICustomerContractsTableState {
  
}

export interface ICustomerContractsTableProps extends WithStyles<typeof styles>{
  customerContracts: PaginatedDataDTO<ICustomerContractInDTO>;
  tableColumns?: GridColumns<ICustomerContractInDTO>;
  onRowClick?: (customerContract: ICustomerContractInDTO) => void;
  onFetchElementsOnPage: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  customerAllContractServices: ICustomerContractServiceInDTO[];
  rowsPerPage: number;
  rowHeight?: number;
  disableSelectionOnClick?: boolean;
  isLoading?: boolean;
  allCustomers?: ICustomerInDTO[];
  showCustomer?: boolean;
  onCustomerClick?: (customerId: number) => void;
  onPlantClick?: (plant: any, customerId: number) => void;
}

class CustomerContractsTable extends React.Component<ICustomerContractsTableProps, ICustomerContractsTableState> {
  private defaultColumns: GridColumns<ICustomerContractInDTO>;
  
  constructor(props: ICustomerContractsTableProps) {
    super(props);
    this.state = {

    };
  }

  async componentDidMount() {
    
  }

  public render() {
    const { customerContracts, showCustomer, allCustomers, customerAllContractServices, rowsPerPage, disableSelectionOnClick, onRowClick, onPageSizeChange, onFetchElementsOnPage, tableColumns, rowHeight } = this.props;
    
    this.defaultColumns = [
      {
        field: 'contractInfo',
        headerName: translations.t('gateways.name'),
        type: 'string',
        sortable: true,
        filterable: true,
        minWidth: 300,
        flex: 1.5,
        renderCell: (params: GridRenderCellParams<any>) => {
          const customerContract = params.row;
          return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
              <h3 style={{ margin: '0 0 8px 0', fontWeight: 'bold', fontSize: 14 }}>{customerContract.name}</h3>
              <div style={{ marginBottom: 8 }}>
                <span style={{ color: getCustomerContractStatusColor(customerContract.status || ""), fontWeight: 'bold', fontSize: 13, whiteSpace: 'normal' }}>
                  {customerContract.status ? translations.t(`credits.customerContractStatus_${customerContract.status}`).toUpperCase() : '---'}
                </span>
              </div>
              <div>
                <span style={{ fontSize: 13 }}>{customerContract.expirationDate ? moment(customerContract.expirationDate).format('DD/MM/YYYY') : '---'}</span>
              </div>
            </div>
        )}
      },
      ...(showCustomer ? [{
        field: 'customer',
        headerName: translations.t('credits.customerName'),
        type: 'string',
        sortable: true,
        filterable: true,
        minWidth: 150,
        flex: 1,
        renderCell: (params: GridRenderCellParams<any>) => {
          const customerContract = params.row;
          const customerId = customerContract.customerId;
          const customerName = customerContract.customerName;
          return (
            <div>
              {customerId && customerName ? (
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <CustomersIcon style={{ fontSize: 15, fontWeight: 'bold', color: 'slateblue'  }}/>
                    <h4
                      className={"linkLabel"}
                      style={{ padding: 6, marginLeft: 0, fontSize: 13, fontWeight: 'bold', color: 'slateblue', whiteSpace: 'normal' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.props.onCustomerClick(customerId);
                      }}
                    >
                      {customerName}
                    </h4>
                  </div>
              ):null}
            </div>
          )
        }
      }] : []),
      {
        field: 'plants',
        headerName: translations.t('credits.plants'),
        type: 'string',
        sortable: true,
        filterable: true,
        minWidth: 200,
        flex: 1,
        renderCell: (params: GridRenderCellParams<any>) => {
          const customerContract = params.row;
          const plantsCount = customerContract.plants ? customerContract.plants.length : 0;
          const maxPlantsToShow = 3;
          const hasMorePlants = plantsCount > maxPlantsToShow;
          
          return (
            <div style={{ width: '100%' }}>
              {customerContract.plants && customerContract.plants.length > 0 ? (
                <div style={{ fontSize: 13, lineHeight: '1.2' }}>
                  {customerContract.plants.slice(0, maxPlantsToShow).map((plant, index) => (
                    <div key={plant.id || index} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                      <DomainsIcon style={{ fontSize: 15, fontWeight: 'bold', color: 'slateblue'  }}/>
                      <h4
                        className={"linkLabel"}
                        style={{ padding: 6, paddingTop: 0, paddingBottom: 0, marginLeft: 0, fontSize: 13, fontWeight: 'bold', color: 'slateblue', whiteSpace: 'normal' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (this.props.onPlantClick) {
                            this.props.onPlantClick(plant, customerContract.customerId);
                          }
                        }}
                      >
                        {(plant.hostname || "").replace("api-","").replace(".jago.cloud","")}
                      </h4>
                    </div>
                  ))}
                  {hasMorePlants && (
                    <div style={{ fontSize: 13, fontStyle: 'italic', color: 'gray', marginTop: 4 }}>
                      <ReduxLanguage languageKey="credits.andMorePlants" languageProps={{ count: plantsCount - maxPlantsToShow }} />
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ fontSize: 13, fontStyle: 'italic', color: 'gray' }}>
                  <ReduxLanguage languageKey="credits.noPlantsAssociated" />
                </div>
              )}
            </div>
        )}
      },
      {
        field: 'services',
        headerName: translations.t('credits.contractServices'),
        type: 'string',
        sortable: true,
        filterable: true,
        minWidth: 250,
        flex: 1.5,
        renderCell: (params: GridRenderCellParams<any>) => {
          const customerContract = params.row;
          const contractServices = customerAllContractServices.filter(service => 
            service.customerContractId === customerContract.id
          );
          const servicesCount = contractServices.length;
          const maxServicesToShow = 3;
          const hasMoreServices = servicesCount > maxServicesToShow;
          
          return (
            <div style={{ width: '100%' }}>
              {contractServices.length > 0 ? (
                <div style={{ fontSize: 13, lineHeight: '1.2' }}>
                  {contractServices.slice(0, maxServicesToShow).map((service, index) => (
                    <div key={service.id || index} style={{ marginBottom: 2 }}>
                      <span style={{ fontWeight: 'bold' }}>{service.code}</span> - <span style={{ fontWeight: 'normal' }}>{service.subject}</span>
                    </div>
                  ))}
                  {hasMoreServices && (
                    <div style={{ fontSize: 13, fontStyle: 'italic', color: 'gray', marginTop: 4 }}>
                      <ReduxLanguage languageKey="credits.andMoreServices" languageProps={{ count: servicesCount - maxServicesToShow }} />
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ fontSize: 13, fontStyle: 'italic', color: 'gray' }}>
                  <ReduxLanguage languageKey="credits.noServicesAssociated" />
                </div>
              )}
            </div>
        )}
      },
    ];

    return (
      <DataGrid
        getRowId={(d) => d.id}
        rows={customerContracts.content || []}
        columns={tableColumns ? tableColumns: this.defaultColumns}
        rowHeight={rowHeight ? rowHeight: 100}
        onPageSizeChange={(pageSize) => onPageSizeChange(pageSize)}
        onPageChange={page => onFetchElementsOnPage(page)}
        page={(customerContracts?.pagination as PaginationDTO)?.number}
        rowCount={(customerContracts?.pagination as PaginationDTO)?.totalElements}
        pageSize={rowsPerPage}
        loading={this.props.isLoading}
        onRowClick={row => onRowClick ? onRowClick(row.row) : null}
        paginationMode="server"
        disableSelectionOnClick={disableSelectionOnClick}
        componentsProps={{
          pagination: {
            labelRowsPerPage: translations.t('forms.rowsPerPage')
          }
        }}
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                <SearchOutlined style={{ alignSelf: 'center' }} />
                <h3 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: 0 }}><ReduxLanguage languageKey='credits.noCustomerContractFindTitle' /></h3>
                <h4 style={{ textAlign: 'center', marginTop: 0 }}><ReduxLanguage languageKey='credits.noCustomerContractFindDescription' /></h4>
              </div>
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              <h3 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: 0 }}><ReduxLanguage languageKey='credits.noCustomerContractFindTitle' /></h3>
              <h4 style={{ textAlign: 'center', marginTop: 0 }}><ReduxLanguage languageKey='credits.noCustomerContractFindDescription' /></h4>
            </Stack>
          )
        }}
        sx={{
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
        }}
      />
    );
  }
}

export default withStyles(styles)(CustomerContractsTable);